export const Colors = {
  WHITE: "#FFFFFF",
  PRIMARY_RED: "#E44D52",
};
